<template>
    <vPersonContractComponent :postList="postList" v-if="flag"></vPersonContractComponent>
</template>
<script>
import vPersonContractComponent from '../../listComponent/basicdata/personContract/personContractComponent.vue';
export default {
    name: 'personContract',
    components: {
        vPersonContractComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                code: true,
                date: true,
                type: true,
                labour_contract_entity_rid: true,
                person_rid: true,
                employment_form: true,
                status: true,
                is_competition_agreement: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                addBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>